import { DomUtils } from './utils';

class Swipers {
    constructor(Swiper) {
        if (typeof Swiper == 'undefined') {
            return;
        }

        this.viewportWidth = DomUtils.getViewportWidth();
        this.vw = this.viewportWidth / 100;
        this.createSwiperCards();
        this.createSwiperProducts();
        this.createSwiperCaseProducts();
        this.createSwiperGallery();
        this.createSwiperProductGallery();
    }

    createSwiperCards() {
        const elements = document.querySelectorAll('.swiper-cards');
        if (elements.length) {
            elements.forEach((element) => {
                const swiperElement = element;
                // let navigationPrev = element.querySelector('.swiper-button-prev');
                // let navigationNext = element.querySelector('.swiper-button-next');
                new Swiper(swiperElement, {
                    slidesPerView: 1.25,
                    spaceBetween: 20,
                    lazyPreloadPrevNext: 1,
                    grabCursor: true,
                    // navigation: {
                    //     addIcons: false,
                    //     nextEl: navigationNext,
                    //     prevEl: navigationPrev
                    // },
                    keyboard: {
                        onlyInViewport: true
                    },
                    mousewheel: {
                        forceToAxis: true
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 1.75
                        },
                        1020: {
                            slidesPerView: 2.5
                        },
                        1200: {
                            slidesPerView: 3
                        }
                    }
                });
            });
        }
    }
    createSwiperProducts() {
        const elements = document.querySelectorAll('.swiper-products');
        if (elements.length) {
            elements.forEach((element) => {
                const swiperElement = element;
                // let navigationPrev = element.querySelector('.swiper-button-prev');
                // let navigationNext = element.querySelector('.swiper-button-next');
                new Swiper(swiperElement, {
                    slidesPerView: 1.25,
                    spaceBetween: 20,
                    lazyPreloadPrevNext: 1,
                    grabCursor: true,
                    // navigation: {
                    //     addIcons: false,
                    //     nextEl: navigationNext,
                    //     prevEl: navigationPrev
                    // },
                    keyboard: {
                        onlyInViewport: true
                    },
                    mousewheel: {
                        forceToAxis: true
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 2.25
                        },
                        1020: {
                            slidesPerView: 3
                        },
                        1200: {
                            slidesPerView: 4
                        }
                    }
                });
            });
        }
    }
    createSwiperCaseProducts() {
        const elements = document.querySelectorAll('.block-case-products');
        if (elements.length) {
            elements.forEach((element) => {
                const swiperElement = element.querySelector('.swiper');
                // let navigationPrev = element.querySelector('.swiper-button-prev');
                // let navigationNext = element.querySelector('.swiper-button-next');
                new Swiper(swiperElement, {
                    slidesPerView: 1.25,
                    spaceBetween: 20,
                    lazyPreloadPrevNext: 1,
                    grabCursor: true,
                    // navigation: {
                    //     addIcons: false,
                    //     nextEl: navigationNext,
                    //     prevEl: navigationPrev
                    // },
                    keyboard: {
                        onlyInViewport: true
                    },
                    mousewheel: {
                        forceToAxis: true
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 1.5
                        },
                        1020: {
                            slidesPerView: 1.75
                        },
                        1200: {
                            slidesPerView: 2
                        }
                    }
                });
            });
        }
    }

    createSwiperGallery() {
        const elements = document.querySelectorAll('.block-gallery');
        if (elements.length) {
            elements.forEach((element) => {
                const swiperElement = element.querySelector('.swiper-gallery');
                // let navigationPrev = element.querySelector('.swiper-button-prev');
                // let navigationNext = element.querySelector('.swiper-button-next');
                new Swiper(swiperElement, {
                    slidesPerView: 1.25,
                    spaceBetween: 20,
                    lazyPreloadPrevNext: 1,
                    // grabCursor: true,
                    // navigation: {
                    //     addIcons: false,
                    //     nextEl: navigationNext,
                    //     prevEl: navigationPrev
                    // },
                    touchEventsTarget: 'container',
                    keyboard: {
                        onlyInViewport: true
                    },
                    mousewheel: {
                        forceToAxis: true
                    },
                    breakpoints: {
                        600: {
                            slidesPerView: 1.5
                        },
                        1020: {
                            slidesPerView: 2.7
                        },
                        1200: {
                            slidesPerView: 2.3
                        }
                    }
                });
            });
        }
    }

    createSwiperProductGallery() {
        const elements = document.querySelectorAll('.swiper-product-gallery');
        if (elements.length) {
            elements.forEach((element) => {
                const swiperElement = element;
                let navigationPrev = element.querySelector('.swiper-button-prev');
                let navigationNext = element.querySelector('.swiper-button-next');
                new Swiper(swiperElement, {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    lazyPreloadPrevNext: 1,
                    // grabCursor: true,
                    navigation: {
                        addIcons: false,
                        nextEl: navigationNext,
                        prevEl: navigationPrev
                    },
                    touchEventsTarget: 'container',
                    keyboard: {
                        onlyInViewport: true
                    },
                    mousewheel: {
                        forceToAxis: true
                    }
                });
            });
        }
    }
}
new Swipers(Swiper);
